export const config = {
  description: {
    preferTourOperatorDescription: false
  },
  attributes: {
    favoriteAttributes: [
    // TODO: Remove these when Hotel Content API feature test is through
    'IT03-POOL#HEAT#G200', 'IT03-POOL#OUT#G145', 'IT03-POOL#IN#G144', 'IT03-HOT#AC#G210', 'IT03-HOT#24R#G69', 'IT03-HOT#DCHAIR#G150', 'IT03-HOT#INTE#G95', 'IT03-HOT#PARK#G101', 'IT03-HOT#BIKE#G100', 'IT03-CHI#ANI#G185', 'IT03-CHI#WSLI#G2086', 'IT03-CHI#PLAY#G104', 'IT03-CHI#CLUB#G103', 'IT03-CHI#POOL#G148', 'IT03-SPO#FITSTU#G173', 'IT03-SPO#TENNIS#G195', 'IT03-SPO#BVOLLEY#G178', 'IT03-SPO#GOLF#G183', 'IT03-WELL#SAUN#G154', 'IT03-WELL#MASS#G157', 'IT03-WELL#STEAMB#G156', 'IT03-WELL#WHIRLP#G153',
    // Hotel Content API mapping
    'IT03-POOL#HEAT', 'IT03-POOL#OUT', 'IT03-POOL#IN', 'IT03-HOT#AC', 'IT03-HOT#24R', 'IT03-HOT#DCHAIR', 'IT03-HOT#INTE', 'IT03-HOT#PARK', 'IT03-HOT#BIKE', 'IT03-CHI#ANI', 'IT03-CHI#WSLI', 'IT03-CHI#PLAY', 'IT03-CHI#CLUB', 'IT03-CHI#POOL', 'IT03-SPO#FITSTU', 'IT03-SPO#TENNIS', 'IT03-SPO#BVOLLEY', 'IT03-SPO#GOLF', 'IT03-WELL#SAUN', 'IT03-WELL#MASS', 'IT03-WELL#STEAMB', 'IT03-WELL#WHIRLP'],
    favoriteAttributesLimit: 16
  },
  rating: {
    scoreMaxBackend: 100,
    scoreMaxFrontend: 5,
    scoreThresholds: {
      excellent: 4.4,
      veryGood: 4.1,
      good: 3.75,
      fair: 3.5
    }
  },
  amadeusRating: {
    scoreMaxBackend: 6,
    scoreMaxFrontend: 6,
    scoreThresholds: {
      excellent: {
        min: 5.4
      },
      veryGood: {
        min: 4.8,
        max: 5.3
      },
      good: {
        min: 4.2,
        max: 4.7
      },
      fair: {
        min: 3.6,
        max: 4.1
      },
      weak: {
        min: 1,
        max: 3.5
      }
    },
    recommendationRateEnabled: true
  },
  map: {
    googleMapsApiOptions: {
      googleMapsApiKey: ''
    },
    googleMapsStyleId: ''
  }
};